/* snifz-homepage.js - loaded only on index template */
(function () {
  'use strict';

  /* -- 1. Lenis smooth scroll -- */
  var lenis;
  if (typeof Lenis !== 'undefined') {
    lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.snifzLenis = lenis;
    if (typeof ScrollTrigger !== 'undefined') {
      // GSAP ticker path - don't also start standalone RAF
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function(time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      // Standalone RAF fallback when GSAP not loaded
      function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    }
  }

  /* -- 2. Hero Swiper -- */
  var heroEl = document.querySelector('.hero-swiper');
  var HERO_SEL = '.hero-eyebrow, .hero-headline-1, .hero-headline-2, .hero-sub, .hero-cta';

  if (typeof Swiper !== 'undefined' && heroEl) {
    var heroSwiper = new Swiper('.hero-swiper', {
      /* Speed fix: 'rewind' instead of 'loop' - loop mode re-orders the slide
         DOM on init, which repaints the hero late and pushes back mobile LCP.
         Rewind looks the same (last slide fades back to the first). */
      rewind: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 800,
      autoplay: { delay: 5500, disableOnInteraction: false },
      pagination: { el: '.hero-swiper-pagination', clickable: true },
      navigation: { prevEl: '.hero-swiper-button-prev', nextEl: '.hero-swiper-button-next' },
      on: {
        init: function () { showHeroContent(); },
        slideChangeTransitionStart: function () { animateHeroContent(); }
      }
    });
  }

  /* Speed fix: the first slide is already visible from the HTML/CSS, so do not
     fade it in on load (that delayed LCP). Only later slide changes animate. */
  function showHeroContent() {
    if (typeof gsap === 'undefined') return;
    var slide = document.querySelector('.hero-swiper .swiper-slide-active');
    if (slide) gsap.set(slide.querySelectorAll(HERO_SEL), { opacity: 1, y: 0 });
    if (heroEl) heroEl.classList.add('hero-ready');
    var indicator = document.querySelector('.scroll-indicator');
    if (indicator) gsap.to(indicator, { opacity: 1, delay: 1.1, duration: 0.5 });
  }

  function animateHeroContent() {
    if (typeof gsap === 'undefined') return;
    if (heroEl && !heroEl.classList.contains('hero-ready')) return;
    var slide = document.querySelector('.hero-swiper .swiper-slide-active');
    if (!slide) return;
    var els = slide.querySelectorAll(HERO_SEL);
    if (!els.length) return;
    gsap.killTweensOf(els);
    gsap.fromTo(els, { opacity: 0, y: 32 }, { opacity: 1, y: 0, stagger: 0.1, duration: 0.65, ease: 'power2.out' });
  }

  /* -- 3. Three.js water canvas (desktop only, loaded on demand) -- */
  var waterCanvas = document.getElementById('water-canvas');
  if (waterCanvas && window.innerWidth >= 1024) {
    if (typeof THREE !== 'undefined') {
      initWater();
    } else {
      var threeScript = document.createElement('script');
      threeScript.src = 'https://cdn.jsdelivr.net/npm/three@0.172.0/build/three.min.js';
      threeScript.async = true;
      threeScript.onload = initWater;
      document.head.appendChild(threeScript);
    }
  }

  function initWater() {
    if (typeof THREE === 'undefined') return;
    var canvas = waterCanvas;
    canvas.style.display = 'block';
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
    renderer.setSize(canvas.offsetWidth, canvas.offsetHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    var geo = new THREE.PlaneGeometry(2, 2);
    var uniforms = {
      uTime: { value: 0 },
      uResolution: { value: new THREE.Vector2(canvas.offsetWidth, canvas.offsetHeight) }
    };
    var mat = new THREE.ShaderMaterial({
      uniforms: uniforms,
      transparent: true,
      vertexShader: 'void main(){gl_Position=vec4(position,1.);}',
      fragmentShader: [
        'uniform float uTime;',
        'uniform vec2 uResolution;',
        'void main(){',
        '  vec2 uv=(gl_FragCoord.xy/uResolution)-.5;',
        '  float d=length(uv);',
        '  float wave=sin(d*18.-uTime*1.8)*0.5+0.5;',
        '  float a=wave*0.06*(1.-d*1.6);',
        '  gl_FragColor=vec4(vec3(201./255.,169./255.,98./255.),a);',
        '}'
      ].join('\n')
    });
    scene.add(new THREE.Mesh(geo, mat));
    var clock = new THREE.Clock();
    var rafId;
    function animateWater() {
      uniforms.uTime.value = clock.getElapsedTime();
      renderer.render(scene, camera);
      rafId = requestAnimationFrame(animateWater);
    }
    animateWater();
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('hero') !== -1) {
        cancelAnimationFrame(rafId);
        renderer.dispose();
      }
    });
  }

  /* -- 4. Collections scroll-stack animation (matches HTML version) -- */
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    var collectionsWrap = document.getElementById('collections');
    var collInner = collectionsWrap && collectionsWrap.querySelector('.collections-inner');
    var collSlides = collInner ? Array.from(collInner.querySelectorAll('.c-slide')) : [];

    if (collectionsWrap && collInner && collSlides.length) {
      var n = collSlides.length;

      // Pixel-lock both heights to window.innerHeight and re-measure on
      // resize - mobile browsers change viewport height as the address bar
      // shows/hides while scrolling, and a stale value left a white gap
      // below the pinned section once the bar collapsed.
      function syncCollectionsHeight() {
        var currentVh = window.innerHeight;
        collInner.style.height = currentVh + 'px';
        collectionsWrap.style.height = (n * currentVh) + 'px';
        return currentVh;
      }
      syncCollectionsHeight();

      collSlides.forEach(function (slide, i) {
        if (i === 0) return;
        var img = slide.querySelector('.c-img');
        var texts = slide.querySelectorAll('.c-text');
        gsap.set(slide, { xPercent: 100 });
        if (img) gsap.set(img, { xPercent: -10, scale: 1.08 });
        gsap.set(texts, { y: 48, opacity: 0 });
      });

      var numEl = collInner.querySelector('.c-num');
      var dotEls = Array.from(collInner.querySelectorAll('.c-dot'));

      function setCollActive(idx) {
        if (numEl) {
          gsap.to(numEl, {
            opacity: 0, y: -8, duration: 0.12,
            onComplete: function () {
              numEl.textContent = String(idx + 1).padStart(2, '0');
              gsap.to(numEl, { opacity: 1, y: 0, duration: 0.2 });
            }
          });
        }
        dotEls.forEach(function (d, di) {
          d.style.opacity = di === idx ? '1' : '0.25';
          d.style.transform = di === idx ? 'scaleY(3)' : 'scaleY(1)';
        });
      }

      collSlides.forEach(function (slide, i) {
        if (i === 0) return;
        var img = slide.querySelector('.c-img');
        var texts = slide.querySelectorAll('.c-text');
        gsap.timeline({
          scrollTrigger: {
            trigger: collectionsWrap,
            start: function () { return 'top+=' + ((i - 1) * window.innerHeight) + ' top'; },
            end: function () { return 'top+=' + (i * window.innerHeight) + ' top'; },
            scrub: 1,
            onEnter: function () { setCollActive(i); },
            onEnterBack: function () { setCollActive(i - 1); }
          }
        })
          .to(slide, { xPercent: 0, ease: 'power2.inOut', duration: 1 })
          .to(img, { xPercent: 0, scale: 1, ease: 'power2.inOut', duration: 1 }, 0)
          .to(texts, { y: 0, opacity: 1, stagger: 0.07, ease: 'power3.out', duration: 0.6 }, 0.42);
      });

      // click slide -> navigate to collection
      collInner.addEventListener('click', function (e) {
        var clickable = e.target.closest('.c-clickable');
        if (clickable) {
          var slide = clickable.closest('.c-slide');
          if (slide && slide.dataset.href) window.location.href = slide.dataset.href;
        }
      });

      ScrollTrigger.refresh();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          syncCollectionsHeight();
          ScrollTrigger.refresh();
        }, 200);
      });
    }
  }

  /* -- 5. Stat counter (IntersectionObserver) -- */
  var statEls = document.querySelectorAll('.stat-number[data-value]');
  if (statEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.value, 10);
        var suffix = el.dataset.suffix || '';
        var duration = 1600;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var prog = Math.min((ts - startTime) / duration, 1);
          var val = Math.floor(prog * target);
          el.textContent = val + suffix;
          if (prog < 1) requestAnimationFrame(step);
          else el.textContent = target + suffix;
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    statEls.forEach(function (el) { io.observe(el); });
  }

  /* -- 6. Showcase thumbnail strip -- */
  var showcaseRight = document.querySelector('.showcase-right');
  var thumbStrip = document.getElementById('thumbStrip');
  var showcaseLeft = document.querySelector('.showcase-left');

  if (showcaseRight && thumbStrip) {
    var entries = showcaseRight.querySelectorAll('.showcase-entry');

    // Build thumb strip from entry product images
    entries.forEach(function (entry, i) {
      var src = entry.querySelector('img');
      if (!src) return;
      var btn = document.createElement('button');
      btn.className = 'showcase-thumb-btn' + (i === 0 ? ' active' : '');
      btn.setAttribute('aria-label', 'View ' + (entry.querySelector('.showcase-model') || {}).textContent);
      var img = document.createElement('img');
      img.src = src.src;
      img.alt = src.alt;
      btn.appendChild(img);
      btn.addEventListener('click', function () {
        document.querySelectorAll('.showcase-thumb-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        showcaseRight.scrollTo({ top: entry.offsetTop - 20, behavior: 'smooth' });
      });
      thumbStrip.appendChild(btn);
    });

    // On scroll, sync active state
    showcaseRight.addEventListener('scroll', function () {
      var scrollMid = showcaseRight.scrollTop + showcaseRight.clientHeight / 2;
      entries.forEach(function (entry, i) {
        var top = entry.offsetTop;
        var bot = top + entry.offsetHeight;
        if (scrollMid >= top && scrollMid < bot) {
          document.querySelectorAll('.showcase-thumb-btn').forEach(function (b, bi) {
            b.classList.toggle('active', bi === i);
          });
        }
      });
    }, { passive: true });
  }

  /* -- 7. Mobile testimonials / showrooms slider -- */
  if (typeof Swiper !== 'undefined') {
    if (window.innerWidth < 768) {
      if (document.getElementById('testimonialsSlider') && !document.getElementById('testimonialsSlider').classList.contains('is-marquee')) {
        new Swiper('#testimonialsSlider', {
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: { el: '#testimonialsDots', bulletClass: 'slider-dot', bulletActiveClass: 'active', clickable: true }
        });
      }
      if (document.getElementById('showroomsSlider')) {
        new Swiper('#showroomsSlider', {
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: { el: '#showroomsDots', bulletClass: 'showrooms-dot', bulletActiveClass: 'active', clickable: true }
        });
      }
    }
  }

  /* -- 8. Scroll reveal animations -- */
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function scrollReveal(selector, opts) {
      opts = opts || {};
      var y = opts.y !== undefined ? opts.y : 40;
      var x = opts.x !== undefined ? opts.x : 0;
      var duration = opts.duration || 0.7;
      var delay = opts.delay || 0;
      var stagger = opts.stagger || 0;
      var start = opts.start || 'top 80%';
      var children = opts.children || false;
      document.querySelectorAll(selector).forEach(function (el) {
        var targets = children ? el.children : el;
        gsap.set(targets, { y: y, x: x, opacity: 0 });
        gsap.to(targets, {
          y: 0, x: 0, opacity: 1, duration: duration, delay: delay,
          stagger: stagger || undefined, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: start, toggleActions: 'play none none none' }
        });
      });
    }

    if (!prefersReduced) {
      scrollReveal('.brand-text', { y: 40, duration: 0.8 });
      scrollReveal('.philosophy-section .section-header-center', { y: 30, duration: 0.7 });
      scrollReveal('.pillar-grid', { y: 50, duration: 0.7, stagger: 0.15, start: 'top 75%', children: true });
      scrollReveal('.video-content', { y: 30, duration: 0.7 });
      scrollReveal('.why-section .section-header-center', { y: 30, duration: 0.7 });
      scrollReveal('.badges-row', { y: 30, duration: 0.7, delay: 0.3 });
      scrollReveal('.kitchen-left', { x: -40, duration: 0.8 });
      scrollReveal('.kitchen-right', { x: 40, duration: 0.8 });
      scrollReveal('.testimonials-section .section-header-center', { y: 30, duration: 0.7 });
      scrollReveal('.testimonials-grid', { y: 40, duration: 0.7, stagger: 0.15, start: 'top 75%', children: true });
      scrollReveal('.showrooms-section .section-header-center', { y: 30, duration: 0.7 });
      scrollReveal('.showrooms-grid', { y: 40, duration: 0.6, stagger: 0.1, start: 'top 75%', children: true });
      scrollReveal('.cta-content', { y: 40, duration: 0.8 });

      /* Video section parallax background */
      var videoSection = document.querySelector('.video-section');
      var videoBg = document.querySelector('.video-bg');
      if (videoSection && videoBg) {
        gsap.to(videoBg, {
          yPercent: 20, ease: 'none',
          scrollTrigger: { trigger: videoSection, start: 'top bottom', end: 'bottom top', scrub: true }
        });
      }
    }
  }

  /* -- 9. Appliance selector buttons -- */
  document.querySelectorAll('.appliance-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.appliance-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

})();
